import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { OrganizationLogo } from "../../../../types/Survey";
import { makeUrl } from "../../../../api/makeUrl";

export interface IconImageProps {
    iconImage?: string | OrganizationLogo;
    iconImageStyles?: {
        alignment?: "left" | "center" | "right";
        maxHeight: string;
    };
}

export default function IconImage(props: IconImageProps) {

    if(!props.iconImage){
        return null;
    }

    const iconUrl = typeof props.iconImage === 'string' ?
        props.iconImage :
        makeUrl(`/api/researchkit/organizationbrandingimage/${props.iconImage.organizationID}`);

    return(
            <div className={classNames("step-image-icon", props.iconImageStyles?.alignment || 'center')}>
                <img src={iconUrl} style={{maxHeight: (props.iconImageStyles?.maxHeight || '60')+'px' }} />
            </div>
    );
}